// src/firebase.js

import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'

// Your Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyAlrXYPgqaiFQA9MlB7gz5wZd7pUEwHEXg',
  authDomain: 'spectator-guides.firebaseapp.com',
  projectId: 'spectator-guides',
  storageBucket: 'spectator-guides.appspot.com',
  messagingSenderId: '737830609526',
  appId: '1:737830609526:web:59d56bb2caded524927557'
}

// Initialise Firebase
const firebaseApp = initializeApp(firebaseConfig)

// Initialise services
const auth = getAuth(firebaseApp)
const db = getFirestore(firebaseApp)

// Export to use in other files
export { firebaseApp, auth, db }